import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white border-b border-gray-100" data-id="element-1079">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1080">
        <div className="flex justify-between items-center h-16" data-id="element-1081">
          <div className="flex items-center" data-id="element-1082">
            <Link to="/" className="flex-shrink-0" data-id="element-1083">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KtfgpX5czTsCWioSSfnqq/billvast_logoBB.png" alt="BillVast Logo" className="h-10 w-auto" data-id="element-1084" />
            </Link>
          </div>
          <div className="hidden md:block" data-id="element-1085">
            <div className="ml-10 flex items-center space-x-4" data-id="element-1086">
              <Link to="/" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#289f77]" data-id="element-1087">
                Home
              </Link>
              <Link to="/#features" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#289f77]" data-id="element-1088">
                Features
              </Link>
              <Link to="/#about" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#289f77]" data-id="element-1089">
                About
              </Link>
              <Link to="/#contact" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#289f77]" data-id="element-1090">
                Contact
              </Link>
            </div>
          </div>
          <div className="hidden md:block" data-id="element-1091">
            <div className="ml-4 flex items-center md:ml-6" data-id="element-1092">
              <Link to="/login" className="px-4 py-2 text-sm font-medium text-[#289f77] hover:text-[#115800]" data-id="element-1093">
                Login
              </Link>
              <Link to="/register" className="ml-3 px-4 py-2 text-sm font-medium text-white bg-[#289f77] hover:bg-[#115800] rounded-md" data-id="element-1094">
                Sign Up
              </Link>
            </div>
          </div>
          <div className="flex md:hidden" data-id="element-1095">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#289f77]" data-id="element-1096">
              <span className="sr-only" data-id="element-1097">Open main menu</span>
              {isMenuOpen ? <X className="block h-6 w-6" data-id="element-1098" /> : <Menu className="block h-6 w-6" data-id="element-1099" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-1100">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-1101">
            <Link to="/" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#289f77]" onClick={() => setIsMenuOpen(false)} data-id="element-1102">
              Home
            </Link>
            <Link to="/#features" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#289f77]" onClick={() => setIsMenuOpen(false)} data-id="element-1103">
              Features
            </Link>
            <Link to="/#about" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#289f77]" onClick={() => setIsMenuOpen(false)} data-id="element-1104">
              About
            </Link>
            <Link to="/#contact" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#289f77]" onClick={() => setIsMenuOpen(false)} data-id="element-1105">
              Contact
            </Link>
          </div>
          <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-1106">
            <div className="flex items-center px-5" data-id="element-1107">
              <Link to="/login" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#289f77]" onClick={() => setIsMenuOpen(false)} data-id="element-1108">
                Login
              </Link>
              <Link to="/register" className="block ml-3 px-3 py-2 text-base font-medium text-white bg-[#289f77] hover:bg-[#115800] rounded-md" onClick={() => setIsMenuOpen(false)} data-id="element-1109">
                Sign Up
              </Link>
            </div>
          </div>
        </div>}
    </header>;
};
export default Navbar;